import { render, staticRenderFns } from "./SeparateSubmitModal.vue?vue&type=template&id=b4475c92"
import script from "./SeparateSubmitModal.vue?vue&type=script&lang=js"
export * from "./SeparateSubmitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports